var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('imageDialog',{ref:"imageDialog",attrs:{"max":_vm.maxChooseImage}}),_c('preview',{ref:"preview",attrs:{"previewModel":_vm.previewModel,"previewUrl":_vm.previewUrl},on:{"changePreview":_vm.changePreview}}),_c('skuDialog',{ref:"skuDialog"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }